export var EntityModelType;
(function (EntityModelType) {
    EntityModelType["Action"] = "action";
    EntityModelType["Feedback"] = "feedback";
})(EntityModelType || (EntityModelType = {}));
export function stringifySocketEntityLocation(location) {
    if (typeof location === 'string')
        return location;
    return `${location.stepId}_${location.setId}`;
}
//# sourceMappingURL=EntityModel.js.map